module.exports = __webpack_public_path__ + "img/hapoalim-large.f57f4758.svg";